export * from './src/tags.module';
